/**
 * useTopFundState - State management hook for TopFund component
 */

import { useState, useCallback } from 'react';

export const useTopFundState = () => {
  const [modalState, setModalState] = useState({
    isOpen: false,
    selectedCard: null,
  });

  const toggleModal = useCallback((card) => {
    setModalState(prev => ({
      isOpen: !prev.isOpen,
      selectedCard: card || prev.selectedCard,
    }));
  }, []);

  const closeModal = useCallback(() => {
    setModalState({
      isOpen: false,
      selectedCard: null,
    });
  }, []);

  return {
    modalState,
    toggleModal,
    closeModal,
  };
};
